// AppRedirect.tsx
import { useEffect, useMemo, useRef, useState } from "react";
import QRCodeLib from "qrcode";
import "../styles/store.css";
import Appleimg from "../resources/images/Apple.png";
import Androidimg from "../resources/images/Android.png";

const IOS_APP_URL =
  "https://apps.apple.com";
const ANDROID_WEB_URL =
  "https://play.google.com"; 
// Wenn du statt Fallback-UI auf Desktop umleiten willst, trage hier eine URL ein:
// const FALLBACK_HOME = "/";

function detectPlatform(ua) {
  const u = (ua || navigator.userAgent || "").toLowerCase();
  const isAndroid = /android/.test(u);
  const isIOS =
    /iphone|ipad|ipod/.test(u) ||
    ((/macintosh/.test(u) || /mac os x/.test(u)) && (navigator.maxTouchPoints || 0) > 1);
  if (isAndroid) return "android";
  if (isIOS) return "ios";
  return "unknown";
}

export default function AppRedirect() {
  const ran = useRef(false);
  const [showFallback, setShowFallback] = useState(false);
  const [qrDataUrl, setQrDataUrl] = useState("");

  // aktuelle Seite ohne Query/Hash für einen „sauberen“ QR
  const baseUrl = useMemo(() => {
    try {
      const url = new URL(window.location.href);
      url.search = "";
      url.hash = "";
      return url.toString();
    } catch {
      return typeof window !== "undefined" ? window.location.origin : "";
    }
  }, []);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const override = (params.get("platform") || "").toLowerCase();
    const platform =
      override === "ios" || override === "android" ? override : detectPlatform();

    const doRedirect = () => {
      if (platform === "ios") {
        window.location.replace(IOS_APP_URL);
        return true;
      }
      if (platform === "android") {
        window.location.replace(ANDROID_WEB_URL);
        return true;
      }
      return false;
    };

    const redirected = doRedirect();
    if (!redirected) {
      setShowFallback(true);
      QRCodeLib.toDataURL(baseUrl, { width: 512, margin: 1 })
        .then(setQrDataUrl)
        .catch(() => setQrDataUrl(""));
    }
  }, [baseUrl]);

  if (!showFallback) return null;

  return (
    <div className="app-redirect__wrapper">
      <div className="app-redirect__card">
        <div className="app-redirect__grid">
          {/* Linke Spalte: QR */}
          <div className="app-redirect__left">
            <div className="app-redirect__qrbox">
              {qrDataUrl ? (
                <img
                  src={qrDataUrl}
                  alt="QR-Code zum Öffnen auf dem Smartphone"
                  className="app-redirect__qrimg"
                />
              ) : (
                <div className="app-redirect__qrplaceholder">QR wird geladen …</div>
              )}
              <p className="app-redirect__qrhint">
                Scanne den QR-Code mit deinem Smartphone.
              </p>
            </div>
          </div>

          {/* Rechte Spalte: Badges */}
          <div className="app-redirect__right">
            <h1 className="app-redirect__title">Hol dir Mila auf dein Smartphone</h1>
            <p className="app-redirect__desc">
              Öffne diese Seite auf deinem Smartphone — oder klicke unten auf
              deinen Store:
            </p>

            <div className="app-redirect__badges">
              <a
                href={IOS_APP_URL}
                className="app-redirect__badge-link"
                aria-label="Im App Store laden"
              >
                {/* ersetze Pfade durch deine Assets */}
                <img
                  src={Appleimg}
                  alt="Laden im App Store"
                  className="app-redirect__badge-img"
                />
              </a>

              <a
                href={ANDROID_WEB_URL}
                className="app-redirect__badge-link"
                aria-label="Bei Google Play laden"
              >
                <img
                  src={Androidimg}
                  alt="Jetzt bei Google Play"
                  className="app-redirect__badge-img"
                />
              </a>
            </div>

            <p className="app-redirect__note">
              Der QR-Code führt zurück auf diese Seite und leitet auf dem Handy
              automatisch in den passenden Store.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
